import getLandmarkForPercentageOfDocument from '../getLandmarkForPercentageOfDocument';

/**
 * @method getPageForPercentageOfDocument
 */
const getPageForPercentageOfDocument = (
  frame,
  document,
  percentageOfDocument,
) => {
  return getLandmarkForPercentageOfDocument(
    frame,
    document,
    percentageOfDocument,
    'pages',
  );
};

export default getPageForPercentageOfDocument;
